import LogoutIcon from '@mui/icons-material/Logout';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/core/hooks/useAuth';

const GRADIENT = 'linear-gradient(135deg, #8a2be2, #FFD700)';

export function Header() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <Box
      component="header"
      sx={{
        height: 52,
        bgcolor: '#0A0A0F',
        borderBottom: '1px solid',
        borderImage: `${GRADIENT} 1`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2, md: 3 },
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/dashboard')}
      >
        <Box component="img" src="/logo.png" alt="RunPort コレクト" sx={{ width: 32, mr: 1 }} />
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: '1rem', md: '1.15rem' },
            color: '#fff',
          }}
        >
          RunPort コレクト
        </Typography>
      </Box>
      <Tooltip title="ログアウト">
        <IconButton
          onClick={handleLogout}
          aria-label="ログアウト"
          sx={{
            color: 'rgba(255,255,255,0.4)',
            '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.08)' },
          }}
        >
          <LogoutIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
